/**
 * The poses an AnimationPlayer writes to a Skeleton3D, by the live path of the skeleton (ADR-0016,
 * ADR-0017). The meshes bound to the skeleton listen and update their skin in place.
 */
import { createPushStoreContext } from './pushStore';
const { Provider: AnimatedBonePosesProvider, useStore: useAnimatedBonePoses } = createPushStoreContext('AnimatedBonePosesContext');
export { AnimatedBonePosesProvider, useAnimatedBonePoses };
//# sourceMappingURL=AnimatedBonePosesContext.js.map